import {
  Grid,
  Flex,
  AspectRatio,
  Image,
  Button,
  BoxProps,
} from '@chakra-ui/react'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import { fadeIn } from '@lib/motion'
import { useInViewMotion } from '@lib/hooks'
import { MotionBox, MotionText, Link } from '@ui'
import { createNavLink } from '@utils'

const SsmShop = (props: BoxProps) => {
  const { t } = useTranslation('common')
  const { locale } = useRouter()
  const { controls, ref } = useInViewMotion(true)

  return (
    <MotionBox
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={fadeIn.animationContainer}
    >
      <Grid
        as="section"
        gridTemplateColumns={{ base: '1fr', lg: '1fr 1fr' }}
        templateAreas={{
          base: `'ssm-card-img' 'ssm-card-content'`,
          lg: `' ssm-card-img ssm-card-content'`,
        }}
        {...props}
      >
        <Flex
          flexDirection="column"
          alignItems="flex-start"
          px="padding.primary"
          py={{ base: 'padding.primary', lg: 'padding.primary3' }}
          gridArea="ssm-card-content"
        >
          <MotionText
            variants={fadeIn.up}
            color="red.primary"
            fontSize={{ base: 'xl', lg: '2xl' }}
            mb={{ base: 3, lg: 5 }}
          >
            {t('ssmSupport.title')}
          </MotionText>
          <MotionText
            variants={fadeIn.up}
            fontWeight="light"
            fontSize={{ base: 'sm', lg: 'md' }}
            mb={5}
          >
            {t('ssmSupport.description')}
          </MotionText>
          <MotionBox variants={fadeIn.up}>
            <Button
              fontSize={{ base: 'sm', lg: 'md' }}
              variant="link"
              as={Link}
              href={createNavLink('support', locale)}
            >
              {t('ssmSupport.buttonLabel')}
            </Button>
          </MotionBox>
        </Flex>
        <AspectRatio ratio={1.85 / 1} gridArea="ssm-card-img">
          <Image
            loading="lazy"
            width="full"
            src="https://drupal.sakipsabancimuzesi.org/sites/default/files/2026-04/CAN07938-%40CANBERKULUSAN.jpg"
            fallbackSrc="/img/placeholders/no-image-available-icon.jpeg"
            alt={t('ssmShop.sectionTitle')}
          />
        </AspectRatio>
      </Grid>
    </MotionBox>
  )
}
export default SsmShop
